<template>
  <!-- 专项检查任务 -->
  <div class="edu_pages">
    <div class="edu_pages_content_box">
      <div class="edu_page_title_box">
        <div class="title_box">
          <div class="color_lump_box"></div>
          <span>专项检查任务</span>
        </div>
        <div class="edu_operation_box">
          <div class="add_icon_box button-box" @click="openAddBox()">
            <div></div>
            <span>新增</span>
          </div>
        </div>
      </div>
      <div class="edu_pages_content_body_box">
        <div class="edu_table_box">
          <el-table
            :data="dataList.list"
            height="100%"
            :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
            class="table_box"
          >
            <el-table-column prop="id" label="序号" width="70" align="center">
              <template slot-scope="scope">
                {{
                  listRequestData.pageSize * (listRequestData.pageNum - 1) +
                    scope.$index +
                    1
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="任务名称"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="members"
              label="成员数"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="inspectionItems"
              label="检查项数"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="inspectionStandards"
              label="检查标准数"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="startTime"
              label="开始时间"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="rowData">
                {{ $Common.dateFormatDateTwo(rowData.row.startTime) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="结束时间"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="rowData">
                {{ $Common.dateFormatDateTwo(rowData.row.endTime) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="rowData">
                <el-link
                  type="primary"
                  @click="checkClick(rowData.row.id)"
                  :underline="false"
                  >查看</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="edu_pagination_box">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page="listRequestData.pageNum"
            :page-size="listRequestData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="dataList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加/编辑专项检查任务 -->
    <el-dialog
      title="新增专项检查任务"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="cancelForm"
      :visible.sync="actionDataBox"
      width="40%"
    >
      <div class="dialog_box">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="actionDataInfo"
          label-width="0px"
        >
          <div class="form-row-item-box">
            <div class="form-item-box">
              <span>任务名称:</span>
              <el-form-item prop="title">
                <el-input
                  size="small"
                  clearable
                  style="width:100%"
                  v-model.trim="actionDataInfo.title"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item-box">
              <span>专项指标:</span>
              <el-form-item prop="projectIds">
                <el-select
                  v-model="actionDataInfo.projectIds"
                  multiple
                  size="small"
                  style="width:100%"
                  placeholder="请选择专项指标"
                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.projectName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box" style="width:100%">
              <span>任务日期:</span>
              <el-form-item prop="projectTime">
                <el-date-picker
                  size="small"
                  style="width:100%"
                  v-model="actionDataInfo.projectTime"
                  type="daterange"
                  value-format="timestamp"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <!-- <div class="form-item-box">
              <span>结束日期:</span>
              <el-form-item prop="endTime">
                <el-date-picker
                  size="small"
                  style="width:100%"
                  v-model="actionDataInfo.endTime"
                  type="date"
                  value-format="timestamp"
                  placeholder="选择开始日期"
                >
                </el-date-picker>
              </el-form-item>
            </div> -->
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box" style="width:100%">
              <span>督查小组:</span>
              <el-form-item prop="inspectionTeamIds">
                <el-select
                  v-model="actionDataInfo.inspectionTeamIds"
                  multiple
                  size="small"
                  style="width:100%"
                  placeholder="请选择督查小组"
                >
                  <el-option
                    v-for="item in groupList"
                    :key="item.supTeamId"
                    :label="item.teamName"
                    :value="item.supTeamId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="dialog_save_cancel_box">
          <div class="cancel_item_box" @click="cancelForm">取消</div>
          <div class="save_item_box" @click="lSaveClick('ruleForm')">确定</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="查看"
      :visible.sync="dialogTableVisible"
      width="800px"
      :modal-append-to-body="false"
      :append-to-body="false"
    >
      <el-dialog
        width="700px"
        title="查看任务情况"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div style="height:470px">
          <div
            style="display: flex;justify-content:center;font-size:20px;font-weight: 600;"
          >
            <span>{{ inspectionDetails.title }}</span>
          </div>
          <span style="margin-left:20px;"
            >检查对象：{{ inspectionDetails.schoolName }}</span
          >
          <span
            style="float:right;margin-right:20px;"
            v-if="
              inspectionDetails.status == 1 ||
                inspectionDetails.status == 3 ||
                inspectionDetails.status == 4
            "
          >
            检查时间：{{ $Common.dateFormatDateTwo(inspectionDetails.addTime) }}
          </span>
          <span style="float:right;margin-right:120px;" v-else>
            检查时间：
          </span>
          <div style="max-height:400px;overflow:scroll">
            <el-table :data="inspectionDetails.schoolChecksList">
              <el-table-column type="index" width="50"> </el-table-column>
              <el-table-column
                property="projectName"
                label="项目名称"
                width="200"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                property="standardName"
                label="检查标准"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="自查结果"
                show-overflow-tooltip
                v-if="inspectionDetails.status != 0"
                width="100px"
              >
                <template slot-scope="scope">
                  <span>
                    {{ stateList[scope.row.internalState].name }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="小组结果"
                show-overflow-tooltip
                v-if="inspectionDetails.status != 0"
                width="100px"
              >
                <template slot-scope="scope">
                  <el-select
                    v-if="inspectionDetails.status == 1 && isEdit"
                    v-model="scope.row.teamState"
                    placeholder="请选择小组结果"
                    size="small"
                  >
                    <el-option
                      v-for="item in stateListTwo"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <span>
                    {{ stateList[scope.row.teamState].name }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="督查结果"
                show-overflow-tooltip
                v-if="inspectionDetails.status != 0"
                width="100px"
              >
                <template slot-scope="scope">
                  <el-select
                    v-if="inspectionDetails.status == 3 && isEdit"
                    v-model="scope.row.inspectorState"
                    placeholder="请选择督查结果"
                    size="small"
                  >
                    <el-option
                      v-for="item in stateListTwo"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <span>
                    {{ stateList[scope.row.inspectorState].name }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin:20px;font-size:18px;font-weight: 600;">
              流水记录
            </div>
            <el-timeline
              :reverse="true"
              v-if="
                inspectionDetails.schoolRecordList &&
                  inspectionDetails.schoolRecordList.length > 0
              "
            >
              <el-timeline-item
                v-for="(item, index) in inspectionDetails.schoolRecordList"
                :key="index"
                :timestamp="$Common.dateFormatDateTwo(item.addTime)"
              >
                {{ item.operater }}({{ operaterTypeList[item.type].name }}){{
                  operaterResultList[item.type].name
                }}
              </el-timeline-item>
            </el-timeline>
            <span v-else style="display: flex;justify-content:center;"
              >暂无流水记录</span
            >
          </div>
          <el-button
            type="primary"
            style="float:right;margin-right:20px"
            size="small"
            v-if="inspectionDetails.status == 1 && isEdit"
            @click="saveClick"
          >
            审核
          </el-button>
          <el-button
            type="primary"
            style="float:right;margin-right:20px"
            size="small"
            v-if="inspectionDetails.status == 3 && isEdit"
            @click="saveClick"
          >
            督办
          </el-button>
        </div>
      </el-dialog>
      <el-table :data="inspectionList" max-height="700px">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-tabs tab-position="left" style="max-height: 100px;">
              <el-tab-pane
                v-for="(item, index) in props.row.schoolTeamNameList"
                :key="index"
                :label="item.teamName"
              >
                <div
                  v-for="(iitem, iindex) in item.schoolStatusList"
                  :key="iindex"
                  style="font-size:16px;max-height: 100px;overflow-y:scroll;"
                >
                  {{ iindex + 1 }}:
                  <el-link
                    type="primary"
                    @click="checkInfo(iitem.id, props.row.director)"
                    >{{ iitem.schoolName }}</el-link
                  >
                  <span
                    :style="'color:' + schoolStatusColors[iitem.status]"
                    v-if="iitem.status != null"
                  >
                    ({{
                      $store.state.select.specialTaskStatus[iitem.status]
                        .nameOne
                    }})
                  </span>
                </div>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-table-column>
        <el-table-column label="街道名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              :disabled="scope.row.director == 0 ? false : true"
              content="当前街道未配置街道负责人"
              placement="top"
            >
              <span>
                {{ scope.row.regionName }}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      actionDataBox: false,
      rules: {
        title: [{ required: true, message: " ", trigger: "blur" }],
        projectIds: [{type: 'array', required: true, message: " ", trigger: "change" }],
        projectTime:[{ type: 'array', required: true, message: ' ', trigger: 'change' }],
        inspectionTeamIds: [{type: 'array', required: true, message: " ", trigger: "change" }],
      },
      listRequestData: {
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 20
      },
      dataList: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },

      actionDataInfo: {
        eduId: this.$store.getters.getEduData.eduId,
        title: "",
        projectTime:[],
        startTime: "",
        endTime: "",
        projectIds: "",
        inspectionTeamIds: ""
      },
      groupList: "",
      projectList: "",
      dialogTableVisible: false,
      inspectionList: [],
      innerVisible: false,
      inspectionDetails: {},
      schoolStatusColors: [
        "#FF0000",
        "#000000",
        "#FF7F50",
        "#000000",
        "#00FF7F"
      ],
      isEdit: false, //是否可编辑
      director: "", //街道负责人id
      infoId: ""
    };
  },
  watch: {},
  computed: {
    //   检查结果类型
    stateList() {
      return [
        { id: 0, name: "没有检查" },
        { id: 1, name: "不符合" },
        { id: 2, name: "符合" }
      ];
    },
    stateListTwo() {
      return [
        { id: 1, name: "不符合" },
        { id: 2, name: "符合" }
      ];
    },
    //   操作人类型
    operaterTypeList() {
      return [
        { id: 0, name: "安全主任" },
        { id: 1, name: "小组长" },
        { id: 2, name: "督察员" }
      ];
    },
    //   操作结果类型
    operaterResultList() {
      return [
        { id: 0, name: "已处理" },
        { id: 1, name: "已审核" },
        { id: 2, name: "已督办" }
      ];
    }
  },
  methods: {
    clearData() {
      this.actionDataInfo = {
        eduId: this.$store.getters.getEduData.eduId,
        title: "",
        startTime: "",
        endTime: "",
        projectIds: "",
        inspectionTeamIds: ""
      };
    },
    openAddBox() {
      this.actionDataBox = true;
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
      }, 100);
    },
    cancelForm() {
      this.actionDataBox = false;
      this.$refs.ruleForm.resetFields();
      this.clearData();
    },
    handleCurrentChange(val) {
      this.listRequestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },
    async getDataList() {
      let res = await this.$Http.getEduInspectionTask(this.listRequestData);
      if (res.code == 200) {
        this.dataList.pageSize = res.data.pageSize;
        this.dataList.pageNum = res.data.pageNum;
        this.dataList.total = res.data.total;
        this.dataList.pages = res.data.pages;
        this.dataList.list = res.data.list;
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    async getSpecialIndicatorsList() {
      let res = await this.$Http.getSpecialIndicatorsList({
        eduId: this.$store.getters.getEduData.eduId
      });
      if (res.code == 200) {
        this.projectList = res.data;
        // console.log(this.projectList);
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    async getSupervisionGroupsList() {
      let res = await this.$Http.getSupervisionGroupsList({
        eduId: this.$store.getters.getEduData.eduId
      });
      if (res.code == 200) {
        this.groupList = res.data;
        // console.log(this.groupList);
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    lSaveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDataInfo();
        } else {
          return false;
        }
      });
    },
    async addDataInfo() {
      this.actionDataInfo.startTime = this.actionDataInfo.projectTime[0]
      this.actionDataInfo.endTime = this.actionDataInfo.projectTime[1]
      var req = {
        title: this.actionDataInfo.title,
        startTime: this.actionDataInfo.startTime / 1000,
        endTime: this.actionDataInfo.endTime / 1000,
        projectIds: this.actionDataInfo.projectIds,
        inspectionTeamIds: this.actionDataInfo.inspectionTeamIds,
        eduId: this.actionDataInfo.eduId
      };
      let res = await this.$Http.addEduInspectionTask(req, true);
      if (res.code == 200) {
        this.$message({
          message: res.messsage,
          type: "success"
        });
        this.getDataList();
        this.cancelForm();
        this.actionDataInfo.departmentName = "";
        this.actionDataInfo.departmentLevel = "";
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 获取专项检查任务下的学校执行状态
    async checkClick(id) {
      if (id) {
        this.dialogTableVisible = true;
        let req = {
          specialInspectionId: id
        };
        let res = await this.$Http.getSpecialInspectionSchoolInfo(req);
        if (res.code == 200) {
          let data = res.data || [];
          this.inspectionList = data;
        } else if (res.code == 101) {
          this.inspectionList = [];
        } else {
          this.$message({
            message: res.messsage || "获取失败",
            type: "error"
          });
          this.inspectionList = [];
        }
      }
    },
    checkInfo(id, director) {
      if (id) {
        this.innerVisible = true;
        this.director = director;
        this.infoId = id;
        this.getInfo();
      } else {
        this.$message({
          message: "当前学校存在异常，请先查看其他学校",
          type: "error"
        });
      }
    },
    // 获取专项检查任务下的学校执行状态
    async getInfo() {
      let req = {
        specialInspectionSchoolId: this.infoId
      };
      let res = await this.$Http.getSpecialInspectionTaskDetails(req);
      if (res.code == 200) {
        let data = res.data || {};
        this.inspectionDetails = data;
        if (
          data.status == 1 &&
          data.teamer == this.$store.getters.getUserInfo.userId
        ) {
          // 当检查状态为1时可以审核，审核的时候要校验当前登录id和小组长是否为一个人
          this.isEdit = true;
          this.inspectionDetails.schoolChecksList.map((item) => {
            item.teamState = 2;
            return item;
          });
        } else if (
          data.status == 3 &&
          this.director == this.$store.getters.getUserInfo.userId
        ) {
          // 当检查状态为3时可以督办，督办的时候要校验当前登录id和街道负责人是否为一个人
          this.isEdit = true;
          this.inspectionDetails.schoolChecksList.map((item) => {
            item.inspectorState = 2;
            return item;
          });
        } else {
          this.isEdit = false;
        }
      } else if (res.code == 101) {
        this.inspectionDetails = {};
      } else {
        this.$message({
          message: res.messsage || "获取失败",
          type: "error"
        });
        this.inspectionDetails = {};
      }
    },
    //  审核或督办提交
    async saveClick() {
      let obj = {
        id: this.inspectionDetails.id,
        schoolChecksList: this.inspectionDetails.schoolChecksList,
        schoolRecordList: []
      };
      //   传下一个流程的状态
      if (this.inspectionDetails.status == 1) {
        obj.status = 3;
      } else if (this.inspectionDetails.status == 3) {
        obj.status = 4;
      }
      //   专项检查处理流水记录
      let objc = {
        operateId: this.$store.getters.getUserInfo.userId,
        specialInspectionSchoolId: this.inspectionDetails.id
      };
      if (obj.status == 1) {
        objc.type = 0;
      }
      if (obj.status == 3) {
        objc.type = 1;
      }
      if (obj.status == 4) {
        objc.type = 2;
      }
      obj.schoolRecordList.push(objc);
      let res = await this.$Http.editInspectionInfo(obj);
      if (res.code == 200) {
        this.$message({
          message: this.inspectionDetails.status == 0 ? "检查成功" : "督办成功",
          type: "success"
        });
        this.dialogTableVisible = false;
        this.innerVisible = false;
      } else {
        this.$message({
          message: this.inspectionDetails.status == 0 ? "检查失败" : "督办失败",
          type: "error"
        });
      }
    }
  },
  created() {
    this.getDataList();
    this.getSupervisionGroupsList();
    this.getSpecialIndicatorsList();
  },
  mounted() {}
};
</script>
<style scoped lang="scss">
@import "../../../../public/css/edu_pages.scss";
</style>
